// Phonic Sound — Svelte app entrypoint, bundled by vite_rails.
// Mounted into <div id="app"> in app/views/layouts/application.html.erb.
import { mount } from 'svelte'
import '../app.css'
import App from '../App.svelte'

const target = document.getElementById('app')
const app = target ? mount(App, { target }) : null

export default app
